var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.153 0.330057C12.9486 0.144933 12.6792 0.048451 12.4038 0.061762C12.1284 0.0750729 11.8695 0.197089 11.684 0.401056L5.33998 7.38706L2.27498 4.27107C2.08044 4.08005 1.81867 3.97307 1.54602 3.97315C1.27338 3.97324 1.01167 4.08039 0.817249 4.27154C0.622827 4.46268 0.511227 4.72252 0.506504 4.99513C0.501781 5.26773 0.604311 5.53129 0.791996 5.72906L4.62899 9.62907C4.72566 9.72751 4.84098 9.80571 4.9682 9.85911C5.09543 9.91251 5.23201 9.94002 5.36998 9.94006H5.38999C5.53162 9.93724 5.6712 9.90555 5.80016 9.84692C5.92912 9.78828 6.04476 9.70395 6.13999 9.59907L13.224 1.79907C13.4091 1.59473 13.5056 1.32528 13.4923 1.04988C13.479 0.774469 13.357 0.515592 13.153 0.330057Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.d698f528.svg";
export { ForwardRef as ReactComponent };